import * as React from 'react';
import { Toolbar } from '@fluentui/react-components';

const NotificationToolbar: React.FC = () => (
  <Toolbar>
    <span>Toolbar actions for notifications</span>
  </Toolbar>
);

export default NotificationToolbar;
